module.exports = "/assets/data/fd13071e80c036af88bf19ee0c0598ee-DA5.data.json";